import React from 'react';
const ConfirmIcon = ({ width = "25", height = "25"}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.5 11.0177L10.5 18.0177L21.5 6.0177" stroke="#9DCF4E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export {ConfirmIcon};